import { render, staticRenderFns } from "./subjectDetail.vue?vue&type=template&id=fb5d3d0e&scoped=true&"
import script from "./subjectDetail.vue?vue&type=script&lang=js&"
export * from "./subjectDetail.vue?vue&type=script&lang=js&"
import style0 from "./subjectDetail.vue?vue&type=style&index=0&id=fb5d3d0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb5d3d0e",
  null
  
)

export default component.exports